const AND_STRING = "en"

export default function formatListString(list, includeAnd = false) {
  if (!list || list.length === 0) {
    return ""
  }
  if (includeAnd && list.length > 1) {
    return `${list.slice(0, -1).join(", ")} ${AND_STRING} ${list[list.length - 1]}`
  }
  return list.join(", ")
}
